module.exports = __webpack_public_path__ + "static/media/logo-artist.45eaea3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/logo-artist.png
// module id = 214
// module chunks = 0